import { ReactNode } from "react";

import { useThemeByPath } from "../hooks/useThemeByPath";

export type HeaderProps = {
  leftElement?: ReactNode;
  centerElement?: ReactNode;
  rightElement?: ReactNode;
  className?: string;
};

export const Header = ({
  leftElement,
  centerElement,
  rightElement,
  className,
}: HeaderProps) => {
  const { headerBackgroundColor } = useThemeByPath();
  return (
    <header
      className={`${headerBackgroundColor} ${className ? className : "px-4 py-2 lg:py-4"} sticky top-0 z-20 flex items-center justify-between`}
    >
      {leftElement}
      {centerElement}
      {rightElement}
    </header>
  );
};
